import { FetchAuth } from "../utils/FetchAuthUtil";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export interface FAQResponse {
    faqs: FAQdto[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export interface FAQdto {
    title: {
        ar: string;
        fr: string;
        eng: string;
    };
    answer: {
        ar: string;
        fr: string;
        eng: string;
    };
    _id: string;
    createdDate: string;
}
    

export class TermsService {
    public static createTerms = async (terms: { eng: string, fr: string, ar: string }, _id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(endpoint + `/websettings/update/${_id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "termsAndConditions": terms
                }),
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    }
}
